import useTranslation from '../../../../features/translation/hooks/useTranslation';
import type { PricingItemResponse } from '../../../../features/pricing/api';
import { LoadingIndicator } from '@festo-ui/react';
import { useAppSelector } from '../../../../app/hooks';

enum TranslationKeys {
  YOUR_PRICE = 'addToCartYourPrice',
  PRICE_NOT_AVAILABLE = 'pricesUnavailable',
}

interface PriceCellProps {
  price: PricingItemResponse | null;
}

const PricingComponent = ({ price }: PriceCellProps) => {
  const t = useTranslation();
  const isLoading = useAppSelector((state) => state.pricing.isLoading);

  return (
    <div className="solution--add_to_basket__price_container">
      {isLoading === 'pending' ? (
        <LoadingIndicator size="small" />
      ) : !price ? (
        <p className="solution--add_to_basket__price_container--price">{t(TranslationKeys.PRICE_NOT_AVAILABLE)}</p>
      ) : (
        <>
          <p className="solution--add_to_basket__price_container--title">{t(TranslationKeys.YOUR_PRICE)}:</p>
          <p className="solution--add_to_basket__price_container--price">
            {price.net} {price.currency}
          </p>
        </>
      )}
    </div>
  );
};

export default PricingComponent;
